
import Vue from 'vue';
import moment from 'moment-timezone'
import router from '@/router/index'
import storage from '@/assets/common/storage/storage.js' // 本地存储
import Clipboard from "clipboard" // https://clipboardjs.com
import popup from '@/assets/common/popup/popup.js' // 全局公共弹窗

const utils = {};

moment.locale('zh-cn'); // 设置中国时间

utils.dateFormat = function (value, fmt) {
  if (fmt === null || fmt === undefined || fmt === 'undefined') {
    fmt = 'yyyy-MM-dd hh:mm:ss';
  }
  let getDate = new Date(value);
  let o = {
    'M+': getDate.getMonth() + 1,
    'd+': getDate.getDate(),
    'h+': getDate.getHours(),
    'm+': getDate.getMinutes(),
    's+': getDate.getSeconds(),
    'q+': Math.floor((getDate.getMonth() + 3) / 3),
    'S': getDate.getMilliseconds()
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt;
};

utils.checkNull = function (value) {
  if (value === null || value === undefined || value === "" || value.length === 0) {
    return true;
  } else {
    return false;
  }
}

/**
 * 获取字典码对应的文本
 * @param {String} code 字典Code
 * @param {Array} dicts 字典码表
 * @param {String} field 字典码字典字段
 * @param {String} resField 字典码结果字段
 * @returns {String}
 */
utils.getDictText = function (code, dicts, field = 'value', resField = 'text') {
  let res = code
  if (!Array.isArray(dicts)) {
    return res
  }
  const obj = dicts.find((item) => {
    return item[field] + '' === code + ''
  })
  if (obj !== undefined && obj[resField]) {
    res = obj[resField]
  }
  return res
}

// 复制到剪切板
utils.clipboard = function (data, e) {
  let event = window.event || e || {}
  if (!event) {
    console.error("复制失败,缺少DOM参数")
    return
  }
  let clipboard = new Clipboard("", {
    text: () => data
  })
  clipboard.on('success', (e) => {
    popup.showMessage("复制成功!");
    clipboard.off('success')
    clipboard.off('error')
    clipboard.destroy()
  });
  clipboard.on('error', (e) => {
    clipboard.off('success')
    clipboard.off('error')
    clipboard.destroy()
  });
  clipboard.onClick(event)
}

/**
 * 判空(字符串 数组 对象 数值)
 */
utils.isEmpty = function (params) {
  if (params === undefined) {
    return true
  }
  if (params === '' || params === null || params.length === 0) {
    return true
  }
  let obj = JSON.stringify(params)
  if (obj === '{}') {
    return true
  }
  return false
}

/**
 * 分母为0或空判断
 */
utils.checkDivisor = function (val) {
  if (val === 0 || val === '0' || val === '' || val === null || val === undefined) {
    return false;
  }
  return true
}


/**
 * 普通时间格式化
 */
utils.momentFormat = function (date, mat) {
  if (date === '' || date === null || date === undefined) {
    return ''
  }
  if (mat === '' || mat === null || mat === undefined) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }
  return moment(date).format(mat)
}
/**
 * 表格时间格式
 * @param row
 * @param column
 * @returns {*}
 */
utils.tableDateFormat = function (row, column) {
  var date = row[column.property]
  if (date === undefined || date === '' || date === null) {
    return ''
  }
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

/**
 * 重置表单
 * @param form
 */
utils.resetForm = function (form) {
  for (let key in form) {
    if (Array.isArray(form[key])) {
      form[key] = []
    } else if (form[key] instanceof Object) {
      form[key] = {}
    } else {
      form[key] = ''
    }
  }
  return form
}

// 数组去重
utils.filterArraySame = function (arr) {
  const temp = new Set(arr)
  return Array.from(temp)
}

/*********************************
 判断查询时间范围是否符合要求
 参数 times 时间数组；day 时间相隔天数
 示例 [new Date(),new Date()], 30
 **********************************/
utils.checkTimeRange = function (times, day) {
  if (!day) {
    day = 30;
  }
  if (
    typeof times === "undefined" ||
    times === null ||
    times.length !== 2 ||
    times === ""
  ) {
    return false;
  }
  if (
    new Date(times[1]).getTime() - new Date(times[0]).getTime() >
    1000 * 60 * 60 * 24 * day
  ) {
    return false;
  }
  return true;
}

// 错误或警告信息弹层
utils.messageTips = (msg, type) => {
  if (document.getElementsByClassName('el-message').length == 0) {
    Vue.prototype.$message({
      message: msg,
      type: type
    });
  }
}
//  js乘法计算精度函数
utils.accMul = function (arg1, arg2, retain = 2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) { }
  try {
    m += s2.split(".")[1].length;
  } catch (e) { }
  let num = Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
  return Number(Number(num).toFixed(retain));
}
//  js乘法计算精度函数,不四舍五入
utils.accMulTwo = function (arg1, arg2, retain = 2) {
  if (arg1 == undefined || arg1 == null) {
    return 0
  } else if (arg2 == undefined || arg2 == null) {
    return 0
  } else {
    var m = 0,
      s1 = arg1 ? arg1.toString() : 0,
      s2 = arg2 ? arg2.toString() : 0;
    try {
      m += s1.split(".")[1].length;
    } catch (e) { }
    try {
      m += s2.split(".")[1].length;
    } catch (e) { }
    let num = Number(s1 ? s1.replace(".", "") : 0) * Number(s2 ? s2.replace(".", "") : 0) / Math.pow(10, m);
    //console.log(num);
    return Number(Number(num).toFixed(retain + 1).slice(0, -1));
  }

}

//  js加法计算精度函数（四舍五入）
utils.accAdd = function (arg1, arg2, retain = 2) {
  var r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  let num = (arg1 * m + arg2 * m) / m;
  return Number(Number(num).toFixed(retain));
}

//  js加法计算精度函数(不四舍五入)
utils.accAddTwo = function (arg1, arg2, retain = 2) {
  var r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  let num = (arg1 * m + arg2 * m) / m;
  return Number(Number(num).toFixed(retain + 1).slice(0, -1));
}

//  除法精度
utils.accDiv = function (arg1, arg2) {
  var t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = arg1.toString().split('.')[1].length;
  } catch (e) { }
  try {
    t2 = arg2.toString().split('.')[1].length;
  } catch (e) { }
  r1 = Number(arg1.toString().replace('.', ''));
  r2 = Number(arg2.toString().replace('.', ''));
  let num = (r1 / r2) * Math.pow(10, t2 - t1);
  return Number(Number(num).toFixed(2));
}

//  js减法计算精度函数
utils.Subtr = function (arg1, arg2, retain = 2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = (r1 >= r2) ? r1 : r2;
  let num = ((arg1 * m - arg2 * m) / m).toFixed(n);
  return Number(Number(num).toFixed(retain));
}
/*-------------------------------- moment 时间相关 ------BEGIN--------------------------------- */



// 返回两个日期的所有日期
utils.getDayAll = function (begin, end, nowSystemTime) {
  begin = begin ? utils.momentFormat(begin, 'YYYY-MM-DD') : '';
  end = end ? utils.momentFormat(end, 'YYYY-MM-DD') : '';
  nowSystemTime = nowSystemTime ? moment().format('YYYY-MM-DD') : '';

  var dateAllArr = new Array();
  var ab = begin.split("-");
  var ae = end.split("-");
  var db = nowSystemTime ? new Date(nowSystemTime) : new Date();
  db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
  var de = nowSystemTime ? new Date(nowSystemTime) : new Date();
  de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
  var unixDb = db.getTime(); // 晚上时间有偏差
  var unixDe = de.getTime();
  // var unixDb = db.getTime() - 24 * 60 * 60 * 1000;
  // var unixDe = de.getTime() - 24 * 60 * 60 * 1000;
  for (var k = unixDb; k <= unixDe;) {
    let temp = utils.momentFormat(new Date(parseInt(k)), 'YYYY-MM-DD')
    dateAllArr.push(temp);
    k = k + 24 * 60 * 60 * 1000;
  }
  return dateAllArr;
}


// 返回两个日期的所有周
utils.getWeekAll = function (begin, end, nowSystemTime) {
  begin = begin ? utils.momentFormat(begin, 'YYYY-MM-DD') : '';
  end = end ? utils.momentFormat(end, 'YYYY-MM-DD') : '';
  nowSystemTime = nowSystemTime ? moment().format('YYYY-MM-DD') : '';

  var weekAllArr = new Array();

  let weekTemp; // 周
  let yearTemp; // 年
  let weekNumTemp = []; // 两个日期之间 所有的周
  let weekNumWithYearTemp = []; // 两个日期之间 所有的周（格式2020-55）

  let mondayTemp = "";
  let sundayTemp = "";
  let weekArrayTemp = [];

  // 两个日期所有的日期
  let dayListTemp = utils.getDayAll(
    begin,
    end,
    nowSystemTime
  );

  // 根据两个日期，获取所有周(比如：['2020-33'])和所有的周期(比如：['2020/08/22~2020/08/29'])
  dayListTemp.forEach((item, index) => {
    weekTemp = utils.getWeekNum(item);
    yearTemp = moment(item).year();
    weekNumTemp.push(weekTemp); // 重复的周
    weekNumWithYearTemp.push(yearTemp + "-" + weekTemp); // 重复的周（格式2020-55）

    // 获取当前两个日期之间的周一和周五
    mondayTemp = utils.getMonday(item);
    // sundayTemp = utils.getSunday(item);
    sundayTemp = utils.getLastSunday(item);
    // weekArrayTemp.push(mondayTemp + "~" + sundayTemp);
    weekArrayTemp.push(sundayTemp);
  });
  // console.log(weekNumWithYearTemp);
  // console.log(weekArrayTemp);
  weekNumTemp = utils.filterArraySame(weekNumTemp); // 去重 两个日期之间 所有的周
  weekNumWithYearTemp = utils.filterArraySame(weekNumWithYearTemp); // 去重 两个日期之间 所有的周（格式2020-55）
  weekArrayTemp = utils.filterArraySame(weekArrayTemp); // 去重 两个日期之间 所有的周（格式2020/08/10~2020/08/16）
  // console.log(weekArrayTemp);

  // weekArrayTemp[0] =
  //   moment(begin).format("YYYY/MM/DD") +
  //   weekArrayTemp[0].substr(-11);
  // weekArrayTemp[weekArrayTemp.length - 1] =
  //   weekArrayTemp[weekArrayTemp.length - 1].substr(0, 11) +
  //   moment(end).format("YYYY/MM/DD");

  // 封装周表格的数据，根据所有周
  weekArrayTemp.forEach((item, index) => {
    weekAllArr.push({
      time: item, // 周日
      week: weekNumTemp[index], // 周数
      weekWithYear: weekNumWithYearTemp[index], // 年-周数
    });
  });

  return weekAllArr;
}

// 按月返回
utils.getMonthAll = function (begin, end, nowSystemTime) {
  begin = begin ? utils.momentFormat(begin, 'YYYY-MM-DD') : '';
  end = end ? utils.momentFormat(end, 'YYYY-MM-DD') : '';
  nowSystemTime = nowSystemTime ? moment().format('YYYY-MM-DD') : '';
  var d1 = begin;
  var d2 = end;
  var dateArry = new Array();
  var s1 = d1.split("-");
  var s2 = d2.split("-");
  var mCount = 0;
  if (parseInt(s1[0]) < parseInt(s2[0])) {
    mCount = (parseInt(s2[0]) - parseInt(s1[0])) * 12 + parseInt(s2[1]) - parseInt(s1[1]) + 1;
  } else {
    mCount = parseInt(s2[1]) - parseInt(s1[1]) + 1;
  }
  if (mCount > 0) {
    var startM = parseInt(s1[1]);
    var startY = parseInt(s1[0]);
    for (var i = 0; i < mCount; i++) {
      if (startM < 12) {
        dateArry[i] = startY + "-" + (startM > 9 ? startM : "0" + startM);
        startM += 1;
      } else {
        dateArry[i] = startY + "-" + (startM > 9 ? startM : "0" + startM);
        startM = 1;
        startY += 1;
      }
    }
  }
  return dateArry;
}


//返回两个日期相差的天数
utils.getDaysBetween = function (date1, date2) {
  date1 = date1 ? moment(date1).format('YYYY-MM-DD') : 0;
  date2 = date2 ? moment(date2).format('YYYY-MM-DD') : 0;
  let diffDays = 0;
  // if (date1 == date2) {  
  //   diffDays = 1;
  // } else {
  //   diffDays = moment(date1).diff(moment(date2),'days');
  // }
  diffDays = Math.abs(moment(date1).diff(moment(date2), 'days')) + 1;
  // console.log(date1);
  // console.log(date2);
  // console.log(diffDays);
  return diffDays;
}

utils.getWeekNum = function (time) {//传入的格式YYYY-MM 
  // return moment(time).add('days', -1).week(); // 后退一天
  return moment(time).add('days', 0).week();
}

utils.getYearNum = function (time) {//传入的格式YYYY-MM 
  // return moment(time).add('days', -1).year(); // 后退一天
  return moment(time).add('days', 0).year();
}

utils.getMonday = function (curTime) {//传入的格式YYYY-MM
  // var weekOfday = moment(curTime,'YYYY-MM-DD').format('E');
  var weekOfday = moment(curTime).format('E'); // 计算指定日期是这周第几天
  var last_monday = moment(curTime).subtract(weekOfday - 1, 'days').format('YYYY/MM/DD');//周一日期
  return last_monday;
}

utils.getSunday = function (curTime) {//传入的格式YYYY-MM
  // var weekOfday = moment(curTime,'YYYY-MM-DD').format('E');
  var weekOfday = moment(curTime).format('E'); // 计算指定日期是这周第几天
  var last_sunday = moment(curTime).add(7 - weekOfday, 'days').format('YYYY/MM/DD'); // 周日日期
  return last_sunday;
}
// 跳转到指定url路径，并想history栈中添加一个记录，点击后退会返回到上一个页面
utils.navigateTo = function (path, params = {}, query = false) {
  if (query) {
    if (path.indexOf("/") != -1) {
      router.push({
        path: path,
        query: params
      })
    } else {
      router.push({
        name: path,
        query: params
      })
    }
  } else {
    if (path.indexOf("/") != -1) {
      router.push({
        path: path,
        params: params
      })
    } else {
      router.push({
        name: path,
        params: params
      })
    }
  }
}
// 提取aliyuncs.com/和第一个?之间所属阿里云的图片名称
utils.aliyunTofileId = function (img) {
  if (typeof img == "string") {
    if (img.match(/aliyuncs.com\/(\S*)\?/)) {
      let fileId = img.match(/aliyuncs.com\/(\S*)\?/)[1];
      if (fileId) {
        let url = `/file/pub/download?fileId=${encodeURIComponent(decodeURIComponent(fileId))}`;
        return url.indexOf('_FMwebp_') !== -1 ? url.replace('_FMwebp_', '_') : url;
      } else {
        return img.indexOf('_FMwebp_') !== -1 ? img.replace('_FMwebp_', '_') : img;
      }
    } else {
      return img.indexOf('_FMwebp_') !== -1 ? img.replace('_FMwebp_', '_') : img;
    }
  } else if (Array.isArray(img)) {
    return img.map((item) => {
      if (item.match(/aliyuncs.com\/(\S*)\?/)) {
        let fileId = item.match(/aliyuncs.com\/(\S*)\?/)[1];
        if (fileId) {
          return item = `/file/pub/download?fileId=${encodeURIComponent(decodeURIComponent(fileId))}`;
        } else {
          return item.indexOf('_FMwebp_') !== -1 ? item.replace('_FMwebp_', '_') : item;
        }
      } else {
        return item.indexOf('_FMwebp_') !== -1 ? item.replace('_FMwebp_', '_') : item;
      }
    })
  }
}
// 获取两个周的相差值,  两个周格式:   2019-33 和 2020-45
utils.getDiffWeek = function (firstTime, secondTime) { //传入的格式YYYY-MM
  let diffWeek = 0;
  let diffYear = 0;
  let curWeek;
  let curYear;
  let curInnerWeek;
  let curInnerYear;
  firstTime = firstTime ? firstTime.split('-') : [];
  secondTime = secondTime ? secondTime.split('-') : [];

  curWeek = Number(firstTime[1]);
  curYear = Number(firstTime[0]);
  curInnerWeek = Number(secondTime[1]);
  curInnerYear = Number(secondTime[0]);

  if (curYear == curInnerYear) { // 两个周是同一年   2020-33 和 2020-45
    diffWeek = Math.abs(curInnerWeek - curWeek);
  } else { // 两个周 不同的年
    diffYear = Math.abs(curInnerYear - curYear);
    diffWeek = Math.abs(curInnerWeek - curWeek + diffYear * 52);
  }
  return diffWeek
}

// 根据年周（2020-33）获取当周的 星期天
utils.getDateSundayFromWeek = function (time, format) {
  time = time ? time : '';
  format = format ? format : 'YYYY-MM-DD';
  let year;
  let week;
  if (time.indexOf('-') > -1) {
    time = time.split('-')
  }

  year = time[0]
  week = time[1]
  if (week == 52) {
    year += 1;
    week = 1;
  }
  // const temp = moment().year(year).week(week).endOf('week').toDate() // 获取当周的周日
  const temp = moment().year(year).week(week - 1).endOf('week').toDate() // 获取上一周的周日
  return moment(temp).format(format);
};

// 根据月 获取月末日期
utils.getMonthEnd = function (curTime, format) {
  format = format ? format : 'YYYY-MM-DD';
  var monthStart = moment(curTime).endOf('month').format(format);//周一日期
  return monthStart;
}

// 获取两个日期之间的所有月列表(如：['2020/08/01~2020/08/30', '2020/09/01~2020/09/31'])
utils.getMonthListBetween = function (startTime, endTime) {

  let monthStart = "";
  let monthEnd = "";
  let monthArr = [];

  // 两个日期所有的日期
  let dayListTemp = utils.getDayAll(
    startTime,
    endTime
  );

  dayListTemp.forEach((item, index) => {
    // 获取两个日期之间的月初和月末
    monthStart = utils.getMonthStart(item, 'YYYY/MM/DD');
    monthEnd = utils.getMonthEnd(item, 'YYYY/MM/DD');
    monthArr.push(monthStart + "~" + monthEnd);
  });

  // console.log(monthArr);
  monthArr = utils.filterArraySame(monthArr); // 去重（格式2020/08/10~2020/08/16）
  // console.log(monthArr);

  // 替换第一天和最后一天
  if (monthArr && monthArr.length > 1) {
    const monthArrFirst = monthArr[0].split('~');
    const monthArrLast = monthArr[monthArr.length - 1].split('~');
    monthArr[0] = moment(startTime).format("YYYY/MM/DD") + '~' + monthArrFirst[1];
    monthArr[monthArr.length - 1] = monthArrLast[0] + '~' + moment(endTime).format("YYYY/MM/DD")
  } else if (monthArr && monthArr.length == 1) {
    monthArr[0] = moment(startTime).format("YYYY/MM/DD") + '~' + moment(endTime).format("YYYY/MM/DD");
  }

  return monthArr;
}
// 时间格式转换 js
utils.changeDateFormat = function (time) {
  if (time) {
    var timeDate = new Date(parseInt(time))
    var date = ''
    date += timeDate.getFullYear() + '-'
    if (timeDate.getMonth() + 1 < 10) {
      date += '0'
    }
    date += timeDate.getMonth() + 1 + '-'
    if (timeDate.getDate() < 10) {
      date += '0'
    }
    date += timeDate.getDate() + ' '

    if (timeDate.getHours() < 10) {
      date += '0'
    }
    date += timeDate.getHours() + ':'
    if (timeDate.getMinutes() < 10) {
      date += '0'
    }
    date += timeDate.getMinutes() + ':'
    if (timeDate.getSeconds() < 10) {
      date += '0'
    }
    return date += timeDate.getSeconds()
  } else {
    return ''
  }
}
// 获取两个月的相差值,  两个周格式:   2019-33 和 2020-45
utils.getDiffMonth = function (firstTime, secondTime) { //传入的格式YYYY-MM

  // console.log(firstTime);
  //  console.log(secondTime);
  let diffMonth = 0;
  let diffYear = 0;
  let curMonth;
  let curYear;
  let secondMonth;
  let secondYear;
  firstTime = firstTime ? firstTime.split('-') : [];
  secondTime = secondTime ? secondTime.split('-') : [];
  curMonth = Number(firstTime[1]);
  curYear = Number(firstTime[0]);
  secondMonth = Number(secondTime[1]);
  secondYear = Number(secondTime[0]);

  if (curYear == secondYear) { // 两个是同一年   2020-33 和 2020-45
    diffMonth = Math.abs(secondMonth - curMonth);
  } else { // 两个不同的年
    diffYear = Math.abs(secondYear - curYear);
    diffMonth = Math.abs(secondMonth - diffMonth + diffYear * 12); // 1年12个月
  }
  return diffMonth
}
utils.KeepTwoDecimals = function (value) {
  if (value && parseFloat(value).toString() != "NaN" && value != 0) {
    let numStr = value.toString();
    let zero = ".";
    for (let i = 0; i < 2; i++) {
      zero = zero + '0';
    }
    let valueStr = numStr.indexOf('.') > 0 ? numStr.replace(/\.\d*/i, function (dotNum) {
      return dotNum.length === 2 ? dotNum + '0' : dotNum.slice(0, 3);
    }) : numStr + zero;
    value = valueStr;
  } else {
    value = '0.00';
  }
  return Number(value);
}
/*********************************
 币种符号格式化
 **********************************/
utils.currencyFormatString = function (currency) {
  if (currency === 'CNY') {
    return '￥'
  } else if (currency === 'USD') {
    return '$'
  } else if (currency === 'JPY') {
    return 'J￥'
  } else if (currency === 'GBP') {
    return '£'
  } else if (currency === 'EUR') {
    return '€'
  } else if (currency === 'AUD') {
    return 'A$'
  } else if (currency === 'HKD') {
    return 'HK$'
  } else if (currency === 'CAD') {
    return 'CDN$'
  } else if (currency === 'KRW') {
    return '₩'
  } else if (currency === 'INR') {
    return '₲'
  } else if (currency === 'IDR') {
    return 'Rp'
  }
}

/**
 * 查检权限
 * @param {String} authId 权限ID
 * @returns {Boolean}
 */
utils.checkAuth = function (authId) {
  let userAuth = JSON.parse(storage.getStorage('Auths'))
  for (let i = 0; i < userAuth.length; i++) {
    if (userAuth[i].id + '' === authId + '') {
      return true
    }
  }
  return false
}

/**
 * 根据商品ID和平台代码返回商品链接
 * @param {String} asin 商品ID
 * @param {String} webSiteCode 平台代码
 * @returns {String}
 */
utils.getProductUrl = function (asin, webSiteCode) {
  switch (webSiteCode) {
    case 'amazon':
    case 'amazon-us':
      return `https://www.amazon.com/dp/${asin}`;
    case 'walmart':
    case 'walmart-us':
      return `https://www.walmart.com/ip/${asin}`
    default:
      return "#";
  }
}

export default utils;
